
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { addInquirySheet } from "@/api/inquiry";
import {COMPANY_LIST, CURRENCY_UNIT_LIST} from "@/constant";
import {
  searchCustomer
} from "@/api/customer";
@Component({
  name: "ModifyDiscounts",
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: "新建询价单" }) private title: "";
  private form = {
    customerId: null,
    company: null,
    hasDeclaration: null,
    currencyType: "USD"
  };

  private list = [
    {
      label: "公司",
      prop: "company",
      key: "company",
      type: "select",
      placeholder: "请选择公司",
      clearable: true,
      maxlength: 100,
      rules: {
        required: true,
        message: "请选择公司",
        trigger: "change",
      },
      options: COMPANY_LIST,
    },
    {
      label: "客户",
      prop: "customerId",
      key: "customerId",
      type: "select",
      value: "",
      placeholder: "请选择客户",
      remote: true,
      remote_method: this.getCustomer,
      clearable: true,
      options: [],
      rules: {
        required: true,
        message: "请选择客户",
        trigger: "change",
      },
      labelKey: "abbreviation",
      valueKey: "id",
    },
    {
      label: "币种",
      prop: "currencyType",
      key: "currencyType",
      type: "select",
      value: "",
      placeholder: "请选择币种",
      options: CURRENCY_UNIT_LIST,
      rules: {
        required: true,
        message: "请选择币种",
        trigger: "change",
      },
      labelKey: "label",
      valueKey: "label",
    },
    // {
    //   label: "是否报关",
    //   prop: "hasDeclaration",
    //   key: "hasDeclaration",
    //   type: "select",
    //   placeholder: "请选择是否报关",
    //   clearable: true,
    //   maxlength: 100,
    //   rules: {
    //     required: true,
    //     message: "请选择是否报关",
    //     trigger: "change",
    //   },
    //   options: [
    //     {
    //       name: "报关",
    //       id: true,
    //       value: true,
    //     },
    //     {
    //       name: "不报关",
    //       id: false,
    //       value: false,
    //     },
    //   ]
    // },
  ];
  private close() {
    this.$emit("update:show", false);
  }
  private open() {
    this.$emit("update:show", true);
  }
  private async submitForm(): Promise<void> {
    (this.$refs.ruleForm as any).$refs.ruleForm.validate(
      async (valid: boolean) => {
        if (valid) {
          try {
            this.addInquirySheet();
          } catch (error) {
            console.error(error);
          }
        }
      }
    );
  }
  private async getCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.list[1].options = res;
  }
  // 新建询价单
  private async addInquirySheet() {
    const { customerId, company, hasDeclaration, currencyType } = this.form;
    let params = {
      customerId,
      company,
      hasDeclaration,
      currencyType
    };
    try {
      await addInquirySheet(params);
      this.$notify({
        title: "成功",
        message: "创建成功",
        type: "success",
        duration: 2000,
      });
      this.close();
      this.form.customerId = null;
      this.form.company = null;
      this.form.hasDeclaration = null;
      this.$emit("success", false);
    } catch {}
  }
}
